import { render } from "./PasswordForAuthenticatedUser.vue?vue&type=template&id=f033e918&scoped=true&ts=true"
import script from "./PasswordForAuthenticatedUser.vue?vue&type=script&lang=ts"
export * from "./PasswordForAuthenticatedUser.vue?vue&type=script&lang=ts"

import "./PasswordForAuthenticatedUser.vue?vue&type=style&index=0&id=f033e918&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f033e918"]])

export default __exports__